export { defineAgent } from "@/agent/server/builder";
export { defineConfig } from "@/agent/server/config";
export { defineMemory } from "@/plugins/defaults/memories/server/builder";
export { defineStore } from "@/plugins/defaults/stores/builder";
export { definePlugin } from "@/plugins/server/builder";

import { generationPlugin } from "@/plugins/defaults/generation/server";
import { memoriesPlugin } from "@/plugins/defaults/memories/server";
import { storesPlugin } from "@/plugins/defaults/stores/server";

// Explicit typing is required to avoid type size explosion with the iterator
type ServerDefaults = {
  readonly generation: typeof generationPlugin;
  readonly memories: typeof memoriesPlugin;
  readonly stores: typeof storesPlugin;
  readonly [Symbol.iterator]: () => Generator<
    typeof generationPlugin | typeof memoriesPlugin | typeof storesPlugin,
    void,
    unknown
  >;
};

export const defaults: { readonly plugins: ServerDefaults } = {
  plugins: {
    generation: generationPlugin,
    memories: memoriesPlugin,
    stores: storesPlugin,
    // Allows defaults to be used as an iterable, e.g., [...defaults.plugins]
    *[Symbol.iterator]() {
      for (const entry of Object.values(this)) yield entry;
    },
  },
} as const;
